<template>
  <v-card flat class="r5">
    <v-container grid-list-md fluid :class="classProp">
      <v-layout row wrap justify-space-between>
        <div class="font-weight-bold text-xs-left align-center di-flex xs12 px-3 py-2 mb-3 flex">
          <span>{{ $t("cash_receipt_form") }} :</span>
          <v-divider class="ml-2" />
        </div>
        <v-flex xs12 :md6="!edit" class="pt-4">
          <v-layout row wrap class="px-3">
            <!-- <v-divider class="flex xs12 my-3"></v-divider> -->
            <async-autocomplete
              outline
              autofocus
              item-value="id"
              persistent-hint
              url="/credits/create"
              item-text="full_name"
              queries="credits=true"
              @setItem="setCustomer"
              :label="$t('customer')"
              v-validate="'required'"
              @change="setDescription"
              :edit-append="editAppend"
              :data-vv-name="'customer'"
              v-model="value.customer_id"
              :data-vv-as="$t('customer')"
              placeholder="Customer Name"
              class="flex xs12 right-hint"
              :error-messages="errors.collect('customer')"
              :hint="
                customerBalance | currency({ symbol: smbl(value.currency_id) })
              "
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </async-autocomplete>
            <v-date
              type="date"
              tabindex="0"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="value.date"
              input_id="credit_date"
              value-type="YYYY-MM-DD"
              :placeholder="$t('date')"
              class="flex xs12 sm6"
              @input="$emit('date-changed')"
              :disabled-date="disableBackDate"
            />
            <v-date
              type="time"
              label="time"
              format="HH:mm:ss"
              :clearable="false"
              v-model="value.time"
              value-type="HH:mm:ss"
              input_id="credit_time"
              :placeholder="$t('time')"
              class="flex xs12 sm6"
              :disabled-time="disableBackDate"
            />
            
            <v-autocomplete
              outline
              item-value="id"
              item-text="name"
              @change="setDescription"
              :items="branchAccounts"
              v-validate="'required'"
              class="flex xs12 sm6"
              placeholder="Cash / Bank"
              :label="$t('payment_type')"
              v-model="value.receiver_id"
              :data-vv-name="'payment_type'"
              :data-vv-as="$t('payment_type')"
              :error-messages="errors.collect('payment_type')"
            />
            <v-autocomplete
              outline
              item-value="id"
              item-text="name"
              placeholder="USD"
              :items="currencies"
              class="flex xs12 sm6"
              :label="$t('currency')"
              v-validate="'required'"
              :data-vv-name="'currency'"
              @change="setDescription"
              v-model="value.currency_id"
              :data-vv-as="$t('currency')"
              :error-messages="errors.collect('currency')"
            />
            <v-text-field
              outline
              persistentHint
              placeholder=" "
              :label="$t('amount')"
              v-model="value.amount"
              :data-vv-name="'amount'"
              v-validate="'required'"
              :data-vv-as="$t('amount')"
              @change="setDescription"
              class="flex xs12 sm12 mb-3 capitalize"
              :hint="value.amount | toWord"
              v-currency="{ currency: null }"
              :error-messages="errors.collect('amount')"
            />
            <!-- <v-combobox
              outline
              placeholder=" "
              :label="$t('risk_profile')"
              v-model="value.risk_category"
              :items="['Low', 'Medium', 'High']"
              class="flex xs12 sm6 mb-3 capitalize"
            /> -->
            <v-textarea
              outline
              rows="0"
              auto-grow
              class="flex xs12"
              placeholder="Notes"
              :label="$t('description')"
              v-model="value.description"
            />
          </v-layout>
          <v-flex xs12 mt-2>
            <v-btn dark raised @click="save" color="primary" :loading="loading">{{ $t("save") }}</v-btn>
            <v-btn
              dark
              outline
              class="mx-0"
              color="primary"
              :loading="loading"
              @click="save(false)"
              :title="$t('save_print')"
            >
              <v-icon class="mx-2">print</v-icon>
            </v-btn>
            <v-btn
              dark
              raised
              outline
              v-if="!edit"
              @click="reset"
              color="primary"
              :loading="loading"
              :title="$t('new_record')"
            >
              <v-icon class="mx-1">mdi-refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex xs12 :md4="!edit" class="mt-3 hidden-sm-and-down">
          <v-layout row wrap class="justify-center mb-3">
            <v-flex xs12 class="di-flex align-center justify-space-between">
              <div class="caption">
                <strong>{{ $t("files") }}</strong>
                <br />
                {{ $t("file_max_notation") }}
              </div>
              <file-chooser text color="secondary" v-model="value.files" />
            </v-flex>
            <v-flex xs12 v-if="value.files && value.files.length > 0" class="mt-3">
              <file-viewer :files="value.files" />
            </v-flex>
          </v-layout>
          <customer-tile :customer="customer" v-if="!edit" />
        </v-flex>
        <v-flex xs12 md6 v-show="false" class="px-4 hidden-xs-only">
          <credit-bill ref="bill" v-bind="{ credit: { ...value }, customer, system }" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { customersMixin, printBill } from "@/mixins/index.js";
import curjs from "currency.js";
export default {
  name: "CreditForm",
  mixins: [customersMixin, printBill],
  props: {
    edit: { default: false },
    classProp: { default: "" },
    value: {
      default: () => ({
        id: null,
        files: [],
        amount: 0,
        description: "",
        customer_id: null,
        date: new Date(),
        time: new Date().getHours() + ":" + new Date().getMinutes()
      })
    }
  },

  data: () => ({
    loading: false,
    customer: {
      accounts: []
    }
  }),

  computed: {
    editAppend() {
      if (this.value.id) return this.value.customer;
      return false;
    },
    system() {
      let system = this.initialData.customers.find(x => x.type == "system");
      return system ? system : {};
    },

    receiver: vm =>
      vm.initialData.customers.find(x => x.id == vm.value.receiver_id) || {
        accounts: []
      },

    customerBalance: vm =>
      (
        vm.customer.accounts.find(
          x => x.currency_id == vm.value.currency_id
        ) || {
          balance: 0
        }
      ).balance,
    currencies: vm => vm.initialData.currencies,

    branchAccounts: vm =>
      vm.initialData.customers.filter(
        x =>
          (x.type == "system" || x.type == "bank") &&
          x.id != vm.value.customer_id
      )
  },

  methods: {
    setCustomer(item) {
      this.customer = item;
      this.setDescription();
    },

    setDescription() {
      if (!this.generate_description) return;
      this.value.description = `${this.$t("credit_description")} ${
        this.customer.name
      } ${this.$t("into")} ${this.receiver.name}`;
    },

    reset() {
      this.customer = {
        type: "external",
        accounts: [],
        details: {}
      };
      this.$emit("reset");
      this.loading = false;
      this.$validator.reset();
    },

    initData() {
      this.reset();
    },

    async save(disablePrint = true) {
      try {
        this.loading = true;
        this.$validator.validateAll().then(succeed => {
          if (succeed) {
            this.value.amount = curjs(this.value.amount).value;
            this.value.number =
              this.value.number ||
              (this.system && this.system.last_form_number++);

            this.axios
              .post("credits", this.value)
              .then(async res => {
                let fils = this.value.files.filter(x => !x.id);
                if (fils.length > 0) {
                  const fd = new FormData();
                  fd.append("fileable_type", "Credit");
                  fd.append("fileable_id", res.data.id);
                  for (const file of fils) {
                    fd.append("files[]", file);
                  }
                  await this.axios.post("files", fd, {
                    headers: {
                      "Content-Type": "multipart/form-data"
                    }
                  });
                }

                this.value.id = res.data.id;
                this.value.time = res.data.time;
                this.value.date = res.data.date;
                this.value.receiver = res.data.receiver;
                await this.getCustomers();
                this.printBill(this.$refs.bill.$el, disablePrint);
                this.$store.commit("showSnackbar", {
                  text: this.$t("save_succeed"),
                  stateType: "success",
                  show: true
                });
                this.loading = false;
                this.$emit("saved", res.data);
                this.reset();
              })
              .catch(error => {
                console.error(error);
                this.$store.commit("showSnackbar", {
                  text: error.response.data.message,
                  stateType: "error",
                  show: true
                });
                this.loading = false;
              });
          } else {
            this.$store.commit("showSnackbar", {
              text: this.$t("wrong_input"),
              stateType: "error",
              show: true
            });
            this.loading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>